import * as React from 'react';
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Link,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginUser } from '../api/authApi';
import { loginSuccess } from '../redux/slices/authSlice';
import backgroundImage from '../assets/bg-login.jpg'; // place the image here
import logo from '../assets/logo.png';
import getApiErrorMessage from '../utils/getApiErrorMessage';

export default function SignInPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = React.useState({ email: '', password: '' });
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [showPassword, setShowPassword] = React.useState(false);

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async () => {
    const email = form.email.trim();
    const password = form.password;

    if (!email || !password) {
      setError('Please enter both email and password to sign in.');
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const { token, user } = await loginUser({ email, password });
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      dispatch(loginSuccess({ user, token }));
      navigate('/');
    } catch (err) {
      console.error('Login failed:', err);
      const msg = getApiErrorMessage(err, 'Invalid email or password');
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 4,
          width: 400,
          maxWidth: '90%',
          borderRadius: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          textAlign: 'center',
        }}
      >
        <img
          src={logo}
          alt="Hudson Valley Dental Lab"
          style={{ width: 280, marginBottom: 16 }}
        />
        <Typography variant="h6" gutterBottom>
          
        </Typography>

        {error && (
          <Typography variant="body2" color="error" gutterBottom>
            {error}
          </Typography>
        )}

        <TextField
          label="Email Address"
          fullWidth
          margin="normal"
          value={form.email}
          onChange={handleChange('email')}
        />
        <TextField
          label="Password"
          type={showPassword ? 'text' : 'password'}
          fullWidth
          margin="normal"
          value={form.password}
          onChange={handleChange('password')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Button
          variant="contained"
          fullWidth
          sx={{ mt: 2 }}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? 'Signing In…' : 'Sign In'}
        </Button>

        <Box
          display="flex"
          justifyContent="space-between"
          mt={2}
        >
          <Link
            href="/signup"
            variant="body2"
            underline="hover"
          >
            New user? Sign up
          </Link>
          <Link
            href="/forgot-password"
            variant="body2"
            underline="hover"
          >
            Forgot password?
          </Link>
        </Box>
      </Paper>
    </Box>
  );
}
